import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullProduct from "../fragments/fullProduct"

const query = gql`
  mutation UpdateProduct($data: ProductUpdateInput!) {
    updateProduct(data: $data) {
      ...fullProduct
    }
  }
  ${fullProduct}
`

export const updateProductKey = getQueryNames(query)[0]

export default query
